(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dillycart-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dillycart-banner')){customElements.define('dillycart-banner',class extends HTMLElement{connectedCallback(){if(this.timer)return;this.slides=Array.from(this.children);this.index=0;this.slides[0]?.classList.add('is-active');this.classList.add('is-ready');this.timer=setInterval(()=>{if(document.hidden||this.contains(document.activeElement)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;this.slides[this.index]?.classList.remove('is-active');this.index=(this.index+1)%this.slides.length;this.slides[this.index]?.classList.add('is-active');},5000);}disconnectedCallback(){clearInterval(this.timer);this.timer=null;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if(!customElements.get('maxsmile-cart-position'))customElements.define('maxsmile-cart-position',class extends HTMLElement{
connectedCallback(){
this.cart=document.getElementById('cart-icon-bubble');
if(!this.cart)return;
this.placeholder=document.createElement('span');
this.placeholder.className='ms-cart-placeholder';
this.placeholder.hidden=true;
this.cart.before(this.placeholder);
this.update=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{
this.frame=null;
const anchor=this.cart.classList.contains('ms-cart-floating')?this.placeholder:this.cart;
const floating=anchor.getBoundingClientRect().bottom<=0;
if(floating&&!this.cart.classList.contains('ms-cart-floating')){
this.placeholder.hidden=false;document.body.append(this.cart);this.cart.classList.add('ms-cart-floating');
}else if(!floating&&this.cart.classList.contains('ms-cart-floating'))this.restore();
});};
window.addEventListener('scroll',this.update,{passive:true});window.addEventListener('resize',this.update);this.update();
}
restore(){this.cart.classList.remove('ms-cart-floating');this.placeholder.after(this.cart);this.placeholder.hidden=true;}
disconnectedCallback(){window.removeEventListener('scroll',this.update);window.removeEventListener('resize',this.update);cancelAnimationFrame(this.frame);if(this.cart&&this.placeholder){this.restore();this.placeholder.remove();}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxsmile-bundle"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('maxsmile-bundle-loader')){
 customElements.define('maxsmile-bundle-loader',class extends HTMLElement{
  connectedCallback(){
   if(this.observer)return;
   this.controller=new AbortController();
   const load=async()=>{
    this.observer?.disconnect();
    try{const response=await fetch(this.dataset.url,{signal:this.controller.signal});if(!response.ok)return;
     const html=new DOMParser().parseFromString(await response.text(),'text/html');
     const bundle=html.querySelector('maxsmile-bundle');if(bundle&&this.isConnected)this.replaceWith(bundle);else this.remove();
    }catch(error){if(error.name!=='AbortError')this.hidden=true;}
   };
   if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'400px'});this.observer.observe(this);}else load();
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.observer=null;}
 });
}

if(!customElements.get('maxsmile-bundle')){
 customElements.define('maxsmile-bundle',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();
   this.money=new Intl.NumberFormat('en-IN',{style:'currency',currency:this.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:this.dataset.currency==='INR'?0:2});
   this.form=this.querySelector('form');this.button=this.querySelector('button');this.prompt=this.button.textContent;
   this.purchase = Array.from(document.querySelectorAll('maxsmile-purchase')).find(el=>el.dataset.productId===this.dataset.productId);
   this.addEventListener('change',event=>{
    if(event.target===this.querySelector('.ms-bundle-row--main select')&&this.purchase){
     const input=this.purchase.form.elements.id;input.value=event.target.value;input.dispatchEvent(new Event('change',{bubbles:true}));
    }else this.update();
   },{signal:this.controller.signal});
   document.addEventListener('maxsmile:selection',event=>{if(event.detail.productId===this.dataset.productId)this.update();},{signal:this.controller.signal});
   this.form.addEventListener('submit',event=>{if(this.busy){event.preventDefault();return;}this.busy=true;this.button.disabled=true;},{signal:this.controller.signal});
   window.addEventListener('pageshow',()=>{this.busy=false;this.update();},{signal:this.controller.signal});this.update();
  }
  update(){
   let total=0,count=0,totalSaving=0,topRow=null,topPrice=Infinity,topPriority=0,eligibleCount=0;
   const main=this.purchase?.selection;
   const mainSelect=this.querySelector('.ms-bundle-row--main select');
   if(main){mainSelect.value=String(main.id);this.querySelector('.ms-bundle-row--main input[type="hidden"]').value=main.quantity;const label=this.querySelector('[data-main-quantity]');if(label)label.textContent=main.quantity>1?`· × ${main.quantity}`:'';}
   const mainPrice=Number(this.querySelector('.ms-bundle-row--main select')?.selectedOptions[0]?.dataset.price)||Infinity;
   const items=[];
   this.querySelectorAll('.ms-bundle-row').forEach(row=>{
    const choice=row.querySelector('[data-bundle-choice]');let selected=!choice||choice.checked;
    const select=row.querySelector('select'),unitPrice=Number(select.selectedOptions[0]?.dataset.price)||0,price=!choice&&main?main.total:unitPrice;
    if(choice&&row.dataset.budgetExempt!=='true'&&price>mainPrice){choice.checked=false;selected=false;row.hidden=true;}else row.hidden=false;
    const badge=row.querySelector('[data-top-pick]');if(badge)badge.hidden=true;
    if(choice){row.classList.remove('ms-bundle-row--featured');if(!row.hidden){eligibleCount++;const priority=Number(row.dataset.pairingPriority)||0;if(priority>topPriority||(priority===topPriority&&priority>0&&price<topPrice)){topPrice=price;topPriority=priority;topRow=row;}}}
    row.querySelectorAll('[name]').forEach(input=>input.disabled=!selected);
    row.querySelector('[data-item-price]').textContent=this.money.format(price/100);
    const compare=!choice&&main?main.compare:Math.max(Number(select.selectedOptions[0]?.dataset.compare)||price,price);
    const compareLabel=row.querySelector('[data-item-compare]'), saving=row.querySelector('[data-item-saving]');
    if(compareLabel){compareLabel.hidden=compare<=price;compareLabel.textContent=this.money.format(compare/100);}
    const mrp=row.querySelector('[data-item-mrp]'),discount=row.querySelector('[data-item-discount]');
    if(mrp)mrp.hidden=compare<=price;
    if(discount){discount.hidden=compare<=price;discount.textContent=discount.dataset.label.replace('__percent__',String(compare>price?Math.round((compare-price)*100/compare):0));}
    if(saving){saving.hidden=compare<=price;saving.textContent=this.dataset.saveLabel.replace('{amount}',this.money.format(Math.max(0,compare-price)/100));}
    if(selected){total+=price;count+=!choice&&main?main.quantity:1;totalSaving+=Math.max(0,compare-price);if(choice)items.push({id:select.value,quantity:1,price,compare});}
   });
   if(topRow){topRow.classList.add('ms-bundle-row--featured');const badge=topRow.querySelector('[data-top-pick]');if(badge)badge.hidden=false;}
   this.style.setProperty('--ms-bundle-columns',Math.max(1,eligibleCount));
   const amounts=this.purchase?.bundleTotals(items);
   if(amounts)total=amounts.total;
   const original=this.querySelector('[data-bundle-original]');
   if(original){original.hidden=!items.length||!amounts?.saving;original.textContent=amounts?this.money.format(amounts.regular/100):'';}
   this.querySelector('[data-bundle-total]').textContent=this.money.format(total/100);
   const savingTotal=this.querySelector('[data-bundle-saving]');
   if(savingTotal){savingTotal.hidden=!items.length||!amounts?.saving;savingTotal.textContent=amounts?this.dataset.extraSavingLabel.replace('{percent}',amounts.rate).replace('{amount}',this.money.format(amounts.saving/100)):'';}
   const offer=this.querySelector('[data-bundle-offer]');
   if(offer){offer.querySelector('[data-bundle-offer-title]').textContent=items.length&&amounts?(amounts.rate===25?this.dataset.fourOfferLabel:offer.dataset.selected):offer.dataset.prompt;}
   this.button.disabled=!!this.busy||!items.length;
   this.button.textContent=!items.length?this.prompt:this.dataset.buttonLabel.replace('{count}',count);
   this.dispatchEvent(new CustomEvent('maxsmile:bundle',{bubbles:true,detail:{productId:this.dataset.productId,items}}));
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;document.dispatchEvent(new CustomEvent('maxsmile:bundle',{detail:{productId:this.dataset.productId,items:[]}}));}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxsmile-diwali-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ms-hero-slider')){
customElements.define('ms-hero-slider',class extends HTMLElement{
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();
const signal=this.controller.signal;
this.track=this.querySelector('.ms-hero-track');
this.pause=this.querySelector('.ms-hero-pause');
this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
this.stopped=this.reduced.matches;
this.hovered=false;
this.updateButton=()=>{this.pause.setAttribute('aria-label',this.stopped?'Play slideshow':'Pause slideshow');this.pause.setAttribute('aria-pressed',String(this.stopped));this.pause.firstElementChild.textContent=this.stopped?'▶':'Ⅱ';};
this.start=()=>{clearTimeout(this.timer);if(this.stopped||this.hovered||document.hidden||this.contains(document.activeElement))return;this.timer=setTimeout(()=>{const width=this.track.clientWidth;const next=(Math.round(this.track.scrollLeft/width)+1)%this.track.children.length;this.track.scrollTo({left:next*width,behavior:this.reduced.matches?'instant':'smooth'});this.start();},5500);};
this.pause.addEventListener('click',()=>{this.stopped=!this.stopped;this.updateButton();this.start();},{signal});
this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;clearTimeout(this.timer);}},{signal});
this.addEventListener('pointerleave',()=>{this.hovered=false;this.start();},{signal});
this.addEventListener('focusin',()=>clearTimeout(this.timer),{signal});
this.addEventListener('focusout',()=>setTimeout(()=>this.start(),0),{signal});
this.track.addEventListener('touchstart',()=>clearTimeout(this.timer),{passive:true,signal});
this.track.addEventListener('touchend',()=>this.start(),{passive:true,signal});
document.addEventListener('visibilitychange',()=>this.start(),{signal});
this.reduced.addEventListener('change',()=>{this.stopped=this.reduced.matches;this.updateButton();this.start();},{signal});
this.updateButton();this.start();
}
disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.controller=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxsmile-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maxsmile-product-suggestions')) {
    customElements.define('maxsmile-product-suggestions', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-slide]');
          const grid = this.querySelector('.ms-product-suggestions__grid');
          if (arrow && grid) grid.scrollBy({left:Number(arrow.dataset.slide) * grid.clientWidth * .9, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal:this.controller.signal});
        if (this.hasAttribute('data-ready')) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load(this.controller.signal);
        }, {rootMargin:'400px'});
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
      async load(signal) {
        try {
          const limit = Math.min(10, Math.max(2, Number(this.dataset.limit) || 4));
          const url = new URL(this.dataset.url, location.origin);
          if (url.origin !== location.origin) return;
          url.searchParams.set('section_id', this.dataset.sectionId);
          let recentIds = [];
          if (this.dataset.mode === 'recently_viewed') {
            let stored;
            try { stored = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]'); } catch { stored = []; }
            recentIds = [...new Set((Array.isArray(stored) ? stored : []).map(String).filter(id => /^\d+$/.test(id) && id !== this.dataset.productId))].slice(0, limit);
            if (!recentIds.length) { this.hidden = true; return; }
            url.searchParams.set('type', 'product');
            url.searchParams.set('q', recentIds.map(id => `id:${id}`).join(' OR '));
          } else {
            if (!/^\d+$/.test(this.dataset.productId)) { this.hidden = true; return; }
            url.searchParams.set('product_id', this.dataset.productId);
            url.searchParams.set('limit', String(limit));
            url.searchParams.set('intent', 'related');
          }
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Product recommendations unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const rendered = [...doc.querySelectorAll('maxsmile-product-suggestions')].find(el => el.dataset.sectionId === this.dataset.sectionId);
          if (signal.aborted) return;
          if (!rendered?.querySelector('.ms-product-card')) { this.hidden = true; return; }
          const grid = rendered.querySelector('.ms-product-suggestions__grid');
          const cards = [...grid.children];
          const seen = new Set();
          for (const card of cards) {
            const id = card.dataset.productId;
            if (id === this.dataset.productId || seen.has(id) || (recentIds.length && !recentIds.includes(id))) card.remove();
            else seen.add(id);
          }
          if (recentIds.length) {
            for (const id of recentIds) {
              const card = [...grid.children].find(el => el.dataset.productId === id);
              if (card) grid.append(card);
            }
          }
          if (!grid.children.length) { this.hidden = true; return; }
          this.replaceChildren(...rendered.childNodes);
          this.setAttribute('data-ready', '');
          this.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
